const COLORS = {
    primary: "#FFFFFF",
    secondary: "#4A4A4A",
    accent: "#FFA903",
    background: "#1D1F20",

    dark: "#292B2D",
    light: "#f5f5f4",

    error: "#7f1d1d",
}

import arrowBtnBg from "../img/arrowBtnBg.png";
import bg from "../img/bg.png";
import bg2 from "../img/bg2.png";
import bgTransparent from "../img/bg-transparent.png";
import icon from "../../assets/icon.png";
import favIcon from "../../assets/favicon.png";

import successIcon from "../img/icons/success.png";
import notesIcon from "../img/icons/notes.png";
import speechIcon from "../img/icons/speech.png";
import medalIcon from "../img/icons/medal.png";
import targetIcon from "../img/icons/target.png";



const IMAGES = {
    arrowBtnBg,
    bg,
    bg2,
    bgTransparent,
    icon,
    favIcon,
    successIcon,
    notesIcon,
    speechIcon,
    medalIcon,
    targetIcon
}

const SIZES = {
    padding: 19,
    borderRadius: 15,
    textBoxRadius: 25,
    h1: 20,
    h2: 16,
    h3: 12,
}

const FONTS = {
    h1_semiBold: {
        fontSize: SIZES.h1,
        fontFamily: "Montserrat_Semibold"
    },
    h2_semiBold: {
        fontSize: SIZES.h2,
        fontFamily: "Montserrat_Semibold"
    },
    h3_semiBold: {
        fontSize: SIZES.h3,
        fontFamily: "Montserrat_Semibold"
    },
    subtitle: {
        color: COLORS.light,
        fontSize: 16,
    },
    title: {
        color: COLORS.primary,
        fontWeight: 'bold',
        fontSize: 24,
        paddingTop: 0
    },
    info: {
        color: COLORS.primary,
        fontWeight: '200',
        fontSize: 14,
        paddingTop: 0
    }

}

export {
    COLORS,
    SIZES,
    FONTS,
    IMAGES
}